import DragIndicatorIcon from "@material-ui/icons/DragIndicator";
import { Box } from "@mui/material";
import { ReactComponent as DeleteIcon } from "assets/icons/Delete.svg";
import { ReactComponent as EditClass } from "assets/icons/EditClass.svg";
import Button from "components/button/Button";
import { useDisableEnterKey } from "hook/useDisableEnterKey";
import { size } from "lodash";
import React, { useState } from "react";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import { toastr } from "react-redux-toastr";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";

const PricingTabs = ({
  items = [],
  activeTab,
  setActiveTab,
  onAdd,
  onDelete,
  onEdit,
  onReorder,
  titleKey = "title",
  className = "top head_wrapper_top",
  allowEdit = true,
  allowDelete = true,
  allowAdd = true,
  minItems = 1,
  duplicateCheck = null,
  hasError = null,
  onBeforeAdd = null,
}) => {
  useDisableEnterKey(true);

  const [addingNew, setAddingNew] = useState(false);
  const [newTabTitle, setNewTabTitle] = useState("");
  const [editedTitle, setEditedTitle] = useState("");
  const [editingIndex, setEditingIndex] = useState(null);

  const handleAddNew = () => {
    if (!newTabTitle.trim()) return;

    // Check for duplicates if function provided
    if (duplicateCheck && duplicateCheck(newTabTitle)) {
      toastr.info("Validation", "Price already exists");
      return;
    }

    if (onAdd) {
      onAdd(newTabTitle);
    }

    setNewTabTitle("");
    setAddingNew(false);
    setActiveTab(items.length);
  };

  const handleEdit = (index) => {
    if (!editedTitle.trim()) return;

    if (duplicateCheck && duplicateCheck(editedTitle, index)) {
      toastr.info("Validation", "Price name already exists");
      return;
    }

    if (onEdit) {
      onEdit(index, editedTitle);
    }
    setEditingIndex(null);
    setEditedTitle("");
  };

  const handleDragEnd = (result) => {
    if (!result.destination) return;
    if (editingIndex !== null) return;

    const { source, destination } = result;

    if (onReorder) {
      onReorder(source.index, destination.index);
    }

    setActiveTab(destination.index);
  };

  const handleDelete = (index) => {
    if (onDelete) {
      onDelete(index);
    }

    if (activeTab === index) {
      setActiveTab(0);
    } else if (activeTab > index) {
      setActiveTab((prev) => prev - 1);
    }
  };

  return (
    <Box className={className}>
      <DragDropContext onDragEnd={handleDragEnd}>
        <Droppable droppableId="tabs" direction="vertical">
          {(provided) => (
            <div {...provided.droppableProps} ref={provided.innerRef}>
              {items?.map((item, index) => (
                <Draggable
                  key={`tab-${index}`}
                  draggableId={`tab-${index}`}
                  index={index}
                >
                  {(provided) => (
                    <Box
                      ref={provided.innerRef}
                      {...provided.draggableProps}
                      {...provided.dragHandleProps}
                      className={`${editingIndex === index ? "editing" : ""} ${
                        activeTab === index
                          ? "cost__option active"
                          : "cost__option"
                      }`}
                    >
                      <Box
                        className="cost__option__value"
                        onClick={() => setActiveTab(index)}
                      >
                        {editingIndex !== index && (
                          <DragIndicatorIcon className="custom-drag-icon" />
                        )}
                        {editingIndex === index ? (
                          <input
                            type="text"
                            className="form-control"
                            maxLength={30}
                            value={editedTitle}
                            onChange={(e) => setEditedTitle(e.target.value)}
                          />
                        ) : item[titleKey].length > 15 ? (
                          item[titleKey].substring(0, 15) + "..."
                        ) : (
                          item[titleKey]
                        )}
 {hasError && hasError(index) && (
        <ErrorOutlineIcon
          style={{
            color: "#dc3545",
            fontSize: 16,
            marginLeft: '5px'
          }}
        />
      )}

                      </Box>

                      <Box className="edit__cost">
                        {editingIndex === index && (
                          <>
                            <Button
                              variant="primary-outline"
                              size="sm"
                              onClick={() => setEditingIndex(null)}
                            >
                              Cancel
                            </Button>
                            <Button
                              variant="primary"
                              size="sm"
                              onClick={() => handleEdit(index)}
                            >
                              Save
                            </Button>
                          </>
                        )}
                      </Box>
                      {editingIndex !== index && (
                        <>
                          {allowEdit && (
                            <Box
                              className="delete__cost"
                              onClick={() => {
                                setEditingIndex(index);
                                setEditedTitle(item[titleKey]);
                              }}
                            >
                              <EditClass />
                            </Box>
                          )}
                          {allowDelete && size(items) > minItems && (
                            <Box
                              className="delete__cost"
                              onClick={() => handleDelete(index)}
                            >
                              <DeleteIcon />
                            </Box>
                          )}
                        </>
                      )}
                    </Box>
                  )}
                </Draggable>
              ))}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>

      {allowAdd && (
        <Box className="add_new_price">
          {addingNew ? (
            <>
              <Box>
                <input
                  type="text"
                  className="form-control"
                  placeholder="+ Add New"
                  maxLength={30}
                  value={newTabTitle}
                  onChange={(e) => setNewTabTitle(e.target.value)}
                />
              </Box>
              <Box className="addNewPrice_actions">
                <Button
                  variant="primary"
                  size="sm"
                  onClick={handleAddNew}
                  style={{ minWidth: "80px" }}
                >
                  Ok
                </Button>
                <Button
                  variant="primary-outline"
                  size="sm"
                  onClick={() => {
                    setAddingNew(false);
                    setNewTabTitle("");
                  }}
                  style={{ minWidth: "80px" }}
                >
                  Cancel
                </Button>
              </Box>
            </>
          ) : (
            <span onClick={async () => {
              if (onBeforeAdd) {
                const result = await onBeforeAdd();
                if (result === false) return;
              }
              setAddingNew(true);
            }} className="add">
              + Add New
            </span>
          )}
        </Box>
      )}
    </Box>
  );
};

export default PricingTabs;
